import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { Globals } from '../objects/Globals';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  private loginUrl: string;
  private serviceUrl: string;

  chartRefresh: Subject<boolean> = new Subject<boolean>();
  chartRefreshChanged$ = this.chartRefresh.asObservable();

  setChartRefresh(refresh: boolean){
    this.chartRefresh.next(refresh);
  }

  getPinnedCharts():Observable<string>{
    var path = this.serviceUrl +"CreateChartCard/PinnedCharts";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  getChart(id:string):Observable<string>{
    var path = this.serviceUrl +"GetChartCard/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  nextChart(id:string):Observable<string>{
    var path = this.serviceUrl +"NextChart/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  previousChart(id:string):Observable<string>{
    var path = this.serviceUrl +"PreviousChart/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  getChartData(id:string, filterSeries:string, filterSelection:string):Observable<string>{
    var path = this.serviceUrl +"GetChartData/" +id + "/" + filterSeries + "?selection=" + filterSelection;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  getFullChartData(id:string):Observable<string>{
    var path = this.serviceUrl +"GetFullChartData/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  expandChart(id:string):Observable<string>{
    var path = this.serviceUrl +"ExpandChart/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { this.loginUrl = this.env.servicePath; this.serviceUrl = this.env.servicePath }
}
